export default __webpack_public_path__ + "static/media/Townhouse main cover.3ff193c4.jpg";